import {Stack, Typography, useTheme} from '@mui/material';
import {CopySection} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {BillsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useBilletDetails} from '../../hooks/useBilletDetails';
import {BarCodeInfoProps} from './types';

const {copiedCodeMessage, paymentCode} = translations['pt-br'].privateFlow.myFinancial;

const BarCodeInfo = ({onCheckOlderBills, copyDataTagId, copyTestId}: BarCodeInfoProps) => {
	const {colors} = useTheme();
	const {showBarCodeButton, linhaDigitavel} = useBilletDetails();
	return (
		<Fragment>
			{showBarCodeButton ? (
				<Stack alignItems={'start'} gap={1} flexWrap="wrap">
					<Typography fontSize={'1rem'} color={colors.light.text.primary}>
						{paymentCode}
					</Typography>
					<CopySection
						dataTagId={{
							copy: copyDataTagId ?? BillsTaggingEnum.CLICK_COPIAR_CODIGO_BOLETO,
						}}
						value={linhaDigitavel?.cdBarra ?? ''}
						highlightedIcons
						mask={CopySectionMaskEnum.WITHOUT_MASK}
						snackbarMessage={copiedCodeMessage}
						customPadding="8px 16px"
						onBeforeCopy={onCheckOlderBills}
						testId={copyTestId}
					/>
				</Stack>
			) : null}
		</Fragment>
	);
};

export {BarCodeInfo};
